import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  initialMinutes?: number;
  className?: string;
  showIcon?: boolean;
}
export function CountdownTimer({
  initialMinutes = 15,
  className = '',
  showIcon = true
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className={`flex items-center font-mono font-bold ${className}`} data-id="element-1">
      {showIcon && <Clock className="w-4 h-4 mr-2" data-id="element-2" />}
      <span data-id="element-3">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </div>;
}